import Vue from "vue";
import VueRouter from "vue-router";

import Media from "../views/Media.vue";
import Stats from "../views/Stats.vue";
import Student from "../views/Student/Student.vue";
import Personal from "../views/Personal.vue";
import Systems from "../views/Systems.vue";
import Layout from "@/components/Layout/index.vue";
import Login from "../views/Login/Login.vue";
import Information from "../views/Information/index.vue";
import Profile from "../views/Profile/index.vue";

// LK
import Knowledge from "../views/LK/Knowledge/index.vue";
import Patients from "../views/LK/Patients/index.vue";
import DirectoryOfDiseases from "../views/LK/DirectoryOfDiseases/index.vue";
import MediaStorage from "../views/LK/MediaStorage/index.vue";
import TestTasks from "../views/LK/TestTasks/index.vue";
import CreateDiagnosticTest from "../views/LK/TestTasks/CreateTest/index.vue";
import Human from "../views/LK/Human/index.vue";
import Directory from "../views/LK/Directory/directory.vue";
import DirectoryIndex from "../views/LK/Directory/index.vue";
import Bodysystems from "../views/LK/Directory/GuideList/BodySystems.vue";
import BodyParts from "../views/LK/Directory/GuideList/BodyParts.vue";
import Organization from "../views/LK/Directory/GuideList/Organization.vue";
import StudyGroups from "../views/LK/Directory/GuideList/StudyGroups.vue";
import StudyDiscipline from "../views/LK/Directory/GuideList/StudyDiscipline.vue";
import StudyTopic from "../views/LK/Directory/GuideList/StudyTopic.vue";
import Mkb10 from "../views/LK/Directory/GuideList/Mkb10.vue";
import Mkb11 from "../views/LK/Directory/GuideList/Mkb11.vue";
import Measurements from "../views/LK/Directory/GuideList/Measurements.vue";
import Analyzers from "../views/LK/Directory/GuideList/Analyzers.vue";
import AnalyzerMeasurement from "../views/LK/Directory/GuideList/AnalyzerMeasurement.vue";
import Speciality from "../views/LK/Directory/GuideList/Speciality.vue";
import PhysResearch from "../views/LK/Directory/GuideList/PhysResearch.vue";
import PhysicalResearch from "../views/LK/Directory/GuideList/PhysicalResearch.vue";
import VitalIndicator from "../views/LK/Directory/GuideList/VitalIndicator.vue";
import Antropometric from "../views/LK/Directory/GuideList/Antropometric.vue";
import PsychicFunction from "../views/LK/Directory/GuideList/PsychicFunction.vue";
import SomaticStatus from "../views/LK/Directory/GuideList/SomaticStatus.vue";
import DisciplineTopic from "../views/LK/Directory/GuideList/DisciplineTopic.vue";
import LabResearch from "../views/LK/Directory/GuideList/LabResearch.vue";
import InstrumentalResearch from "../views/LK/Directory/GuideList/InstrumentalResearch.vue";
import Symptom from "../views/LK/Directory/GuideList/Symptom.vue";
import Anamnesis from "../views/LK/Directory/GuideList/Anamnesis.vue";
import StudyCourse from "../views/LK/Directory/GuideList/StudyCourse.vue";
import Faculties from "../views/LK/Directory/GuideList/Faculties.vue";

// Teacher
import Teacher from "../views/Teacher/index.vue";
import Tasks from "../views/Teacher/Tasks/index.vue";
import Students from "../views/Teacher/Students/index.vue";
import Completed from "../views/Teacher/Completed/index.vue";
import Grade from "../views/Teacher/Grade/index.vue";

// LkStudents
import LkStudents from "../views/LkStudents/index.vue";
import Tests from "../views/LkStudents/Tests/index.vue";
import TestPass from "../views/LkStudents/TestPass/index.vue";
import Training from "../views/LkStudents/Training/index.vue";
import SystemTree from "../views/LkStudents/SystemTree/index.vue";
import Assessment from "../views/LkStudents/Assessment/index.vue";
import DiagnosticTest from "../views/LkStudents/DiagnosticTest/index.vue";
import Choice from "../views/LkStudents/DiagnosticTest/Choice/index.vue";
import Complaints from "../views/LkStudents/DiagnosticTest/Complaints/index.vue";
import AnamnesisDiag from "../views/LkStudents/DiagnosticTest/Anamnesis/index.vue";
import Inspection from "../views/LkStudents/DiagnosticTest/Inspection/index.vue";
import Palpation from "../views/LkStudents/DiagnosticTest/Palpation/index.vue";
import Perkusion from "../views/LkStudents/DiagnosticTest/Perkusion/index.vue";
import Auskultation from "../views/LkStudents/DiagnosticTest/Auskultation/index.vue";
import SyndromalDiagnosis from "../views/LkStudents/DiagnosticTest/SyndromalDiagnosis/index.vue";
import PreliminaryDiagnosis from "../views/LkStudents/DiagnosticTest/PreliminaryDiagnosis/index.vue";
import LaboratoryTests from "../views/LkStudents/DiagnosticTest/LaboratoryTests/index.vue";
import InstrumentalTests from "../views/LkStudents/DiagnosticTest/InstrumentalTests/index.vue";
import FinalDiagnosis from "../views/LkStudents/DiagnosticTest/FinalDiagnosis/index.vue";
import DiagnosisResult from "../views/LkStudents/DiagnosticTest/DiagnosticResults/indexMobile.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: { title: "Авторизация" },
  },
  {
    path: "/information",
    name: "Information",
    component: Information,
    meta: { title: "Информируем Вас" },
  },
  {
    path: "/student/:humanid",
    name: "Student",
    component: Student,
  },
  {
    path: "/systems/:system",
    name: "Systems",
    component: Systems,
  },
  {
    path: "/media",
    name: "Media",
    component: Media,
  },
  {
    path: "/stats",
    name: "Stats",
    component: Stats,
  },
  {
    path: "/personal",
    name: "Personal",
    component: Personal,
  },

  {
    path: "/lk",
    name: "LK",
    component: Layout,
    children: [
      {
        path: "knowledge",
        name: "Knowledge",
        component: Knowledge,
        meta: { title: "Знания" },
      },
      {
        path: "patients",
        name: "Patients",
        component: Patients,
        meta: { title: "Пациенты" },
      },
      {
        path: "profile",
        name: "Profile",
        component: Profile,
        meta: { title: "Профиль" },
      },
      {
        path: "directoryOfDiseases",
        name: "DirectoryOfDiseases",
        component: DirectoryOfDiseases,
        meta: { title: "Справочник заболеваний" },
      },
      {
        path: "directory",
        component: DirectoryIndex,
        children: [
          {
            path: "",
            name: "Directory",
            component: Directory,
            meta: { title: "Справочник" },
          },
          {
            path: "body-systems",
            name: "SprBodySystem",
            component: Bodysystems,
            meta: { title: "Системы организма человека" },
          },
          {
            path: "body-parts",
            name: "SprBodyPart",
            component: BodyParts,
            meta: { title: "Справочник частей тела" },
          },
          {
            path: "organization",
            name: "SprOrganization",
            component: Organization,
            meta: { title: "Справочник организаций" },
          },
          {
            path: "study-groups",
            name: "SprStudyGroups",
            component: StudyGroups,
            meta: { title: "Справочник учебных групп" },
          },
          {
            path: "study-disciplines",
            name: "SprStudyDisciplines",
            component: StudyDiscipline,
            meta: { title: "Справочник дисциплин" },
          },
          {
            path: "study-topics",
            name: "SprStudyTopics",
            component: StudyTopic,
            meta: { title: "Справочник учебных тем" },
          },
          {
            path: "study-mkb10",
            name: "SprMkb10",
            component: Mkb10,
            meta: { title: "Справочник МКБ-10" },
          },
          {
            path: "study-mkb11",
            name: "SprMkb11",
            component: Mkb11,
            meta: { title: "Справочник МКБ-11" },
          },
          {
            path: "measurements",
            name: "SprMeasurement",
            component: Measurements,
            meta: { title: "Справочник единиц измерения" },
          },
          {
            path: "analyzers",
            name: "SprAnalyzer",
            component: Analyzers,
            meta: { title: "Справочник анализаторов" },
          },
          {
            path: "analyzer-measurement",
            name: "SprAnalyzerMeasurement",
            component: AnalyzerMeasurement,
            meta: { title: "Справочник анализаторов и единиц измерения" },
          },
          {
            path: "speciality",
            name: "SprSpeciality",
            component: Speciality,
            meta: { title: "Справочник специальностей" },
          },
          {
            path: "phys-research",
            name: "SprPhysResearch",
            component: PhysResearch,
            meta: { title: "Справочник методов физикальных исследований" },
          },
          {
            path: "physical-research",
            name: "SprPhysicalResearch",
            component: PhysicalResearch,
          },
          {
            path: "vital-indicator",
            name: "SprVitalIndicator",
            component: VitalIndicator,
            meta: { title: "Справочник витальных показателей" },
          },
          {
            path: "antropometric-indicator",
            name: "SprAnthropometricIndicator",
            component: Antropometric,
            meta: { title: "Справочник антропометрических показателей" },
          },
          {
            path: "psychic-function",
            name: "SprMentalFunction",
            component: PsychicFunction,
            meta: { title: "Справочник психических функций" },
          },
          {
            path: "somatic-status",
            name: "SprSomatic",
            component: SomaticStatus,
            meta: { title: "Справочник соматический статус" },
          },
          {
            path: "discipline-topic",
            name: "SprDisciplineTopic",
            component: DisciplineTopic,
            meta: { title: "Справочник учебных тем" },
          },
          {
            path: "lab-research",
            name: "SprLabResearch",
            component: LabResearch,
            meta: { title: "Справочник лабораторных исследований" },
          },
          {
            path: "instrumental-research",
            name: "SprInstrumentalResearch",
            component: InstrumentalResearch,
            meta: { title: "Справочник инструментальных исследований" },
          },
          {
            path: "symptom",
            name: "SprSymptom",
            component: Symptom,
            meta: { title: "Справочник симптомов заболеваний" },
          },
          {
            path: "anamnesis",
            name: "SprAnamnesis",
            component: Anamnesis,
            meta: { title: "Дополнительные сведения о заболевании" },
          },
          {
            path: "study-course",
            name: "SprStudyCourse",
            component: StudyCourse,
            meta: { title: "Справочник учебных курсов" },
          },
          {
            path: "faculties",
            name: "SprFaculty",
            component: Faculties,
            meta: { title: "Справочник учебных курсов" },
          },
        ],
      },
      {
        path: "media-storage",
        name: "MediaStorage",
        component: MediaStorage,
        meta: { title: "Медиатека" },
      },
      {
        path: "test-tasks",
        name: "TestTasks",
        component: TestTasks,
        meta: { title: "Список тестов" },
      },
      {
        path: "test-tasks-diagnostic/:id",
        name: "CreateDiagnosticTest",
        component: CreateDiagnosticTest,
        meta: { title: "Создание диагностического теста" },
      },
      {
        path: "human/:id",
        name: "Human",
        component: Human,
        meta: { title: "Редактирование профиля" },
      },
    ],
  },
  {
    path: "/teacher",
    name: "teacher",
    component: Teacher,
    children: [
      {
        path: "tasks",
        name: "tasks",
        component: Tasks,
        meta: { title: "Список тестов" },
      },
      {
        path: "students",
        name: "students",
        component: Students,
        meta: { title: "Студенты" },
      },
      {
        path: "/teacher/students/:id",
        name: "completed",
        component: Completed,
        meta: { title: "Количество пройденных и назначенных заданий" },
      },
      {
        path: "grade",
        name: "Grade",
        component: Grade,
        meta: { title: "Оценка знаний" },
      },
    ],
  },
  {
    path: "/lkstudents",
    name: "lkstudents",
    component: LkStudents,
    children: [
      {
        path: "tests",
        name: "tests",
        component: Tests,
        meta: { title: "Обучающие тесты" },
      },
      {
        path: "/lkstudents/tests/:id",
        name: "testpass",
        component: TestPass,
        meta: { title: "Прохождение теста" },
      },
      {
        path: "training",
        name: "training",
        component: Training,
        meta: { title: "Системы организма" },
      },
      {
        path: "system-tree/:id",
        name: "SystemTree",
        component: SystemTree,
        meta: { title: "Узел системы организма" },
      },
      {
        path: "assessment",
        name: "Assessment",
        component: Assessment,
        meta: { title: "Оценка знаний" },
      },
    ],
  },
  {
    path: "/lkstudents/dia-test/:id",
    name: "DiagnosticTest",
    component: DiagnosticTest,
    children: [
      {
        path: "",
        name: "Choice",
        component: Choice,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "complaints",
        name: "Complaints",
        component: Complaints,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "anamnesis-diag",
        name: "AnamnesisDiag",
        component: AnamnesisDiag,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "inspection",
        name: "Inspection",
        component: Inspection,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "palpation",
        name: "Palpation",
        component: Palpation,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "perkusion",
        name: "Perkusion",
        component: Perkusion,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "auskultation",
        name: "Auskultation",
        component: Auskultation,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "syndromal-diagnosis",
        name: "SyndromalDiagnosis",
        component: SyndromalDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "preliminary-diagnosis",
        name: "PreliminaryDiagnosis",
        component: PreliminaryDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "laboratory-tests",
        name: "LaboratoryTests",
        component: LaboratoryTests,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "instrumental-tests",
        name: "InstrumentalTests",
        component: InstrumentalTests,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "final-diagnosis",
        name: "FinalDiagnosis",
        component: FinalDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "diagnosis-result",
        name: "DiagnosisResult",
        component: DiagnosisResult,
        meta: { title: "Прохождение диагностического теста" },
      },
    ],
  },
  {
    path: "/lk/dia-test/:id",
    name: "DiagnosticTest",
    component: DiagnosticTest,
    children: [
      {
        path: "",
        name: "Choice",
        component: Choice,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "complaints",
        name: "Complaints",
        component: Complaints,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "anamnesis-diag",
        name: "AnamnesisDiag",
        component: AnamnesisDiag,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "inspection",
        name: "Inspection",
        component: Inspection,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "palpation",
        name: "Palpation",
        component: Palpation,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "perkusion",
        name: "Perkusion",
        component: Perkusion,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "auskultation",
        name: "Auskultation",
        component: Auskultation,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "syndromal-diagnosis",
        name: "SyndromalDiagnosis",
        component: SyndromalDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "preliminary-diagnosis",
        name: "PreliminaryDiagnosis",
        component: PreliminaryDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "laboratory-tests",
        name: "LaboratoryTests",
        component: LaboratoryTests,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "instrumental-tests",
        name: "InstrumentalTests",
        component: InstrumentalTests,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "final-diagnosis",
        name: "FinalDiagnosis",
        component: FinalDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "diagnosis-result",
        name: "DiagnosisResult",
        component: DiagnosisResult,
        meta: { title: "Прохождение диагностического теста" },
      },
    ],
  },
  {
    path: "/teacher/dia-test/:id",
    name: "DiagnosticTest",
    component: DiagnosticTest,
    children: [
      {
        path: "",
        name: "Choice",
        component: Choice,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "complaints",
        name: "Complaints",
        component: Complaints,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "anamnesis-diag",
        name: "AnamnesisDiag",
        component: AnamnesisDiag,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "inspection",
        name: "Inspection",
        component: Inspection,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "palpation",
        name: "Palpation",
        component: Palpation,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "perkusion",
        name: "Perkusion",
        component: Perkusion,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "auskultation",
        name: "Auskultation",
        component: Auskultation,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "syndromal-diagnosis",
        name: "SyndromalDiagnosis",
        component: SyndromalDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "preliminary-diagnosis",
        name: "PreliminaryDiagnosis",
        component: PreliminaryDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "laboratory-tests",
        name: "LaboratoryTests",
        component: LaboratoryTests,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "instrumental-tests",
        name: "InstrumentalTests",
        component: InstrumentalTests,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "final-diagnosis",
        name: "FinalDiagnosis",
        component: FinalDiagnosis,
        meta: { title: "Прохождение диагностического теста" },
      },
      {
        path: "diagnosis-result",
        name: "DiagnosisResult",
        component: DiagnosisResult,
        meta: { title: "Прохождение диагностического теста" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
